import { useContext } from "react";
import { DataManColumnContext } from "../defines";

export const useDataManColumn = () => {
  const context = useContext(DataManColumnContext);
  if (context === undefined) {
    throw new Error(
      "useDataManColumn must be used within a DataManColumnProvider"
    );
  }
  return context;
};
